import { ItemProps } from "@foodpilot/foods";
import { ProductLine } from "src/api/client-api/productLines/useProductLines";

export const buildTreeStructure = (productLines: ProductLine[]): ItemProps[] => {
    // Create a map for quick lookup
    const itemMap = new Map<number, ItemProps>();
    const rootItems: ItemProps[] = [];

    // First pass: create all items
    productLines.forEach((productLine) => {
        const item: ItemProps = {
            id: productLine["@id"], // Use @id as the unique identifier
            label: productLine.name,
            children: [],
        };
        itemMap.set(productLine.id, item);
    });

    // Second pass: build the tree structure
    productLines.forEach((productLine) => {
        const item = itemMap.get(productLine.id);
        if (!item) return;

        if (productLine.parent) {
            // This is a child item
            const parentItem = itemMap.get(productLine.parent.id);
            if (parentItem) {
                parentItem.children = parentItem.children || [];
                parentItem.children.push(item);
            } else {
                // Parent not found, add to root and show hierarchy in label
                item.label = `${productLine.parent.name} > ${productLine.name}`;
                rootItems.push(item);
            }
        } else {
            // This is a root item
            rootItems.push(item);
        }
    });

    return rootItems;
};
